exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._23ccRjp2-Page-module-page{background-color:#fff;margin-bottom:0;padding-bottom:30px}", ""]);

// exports
exports.locals = {
	"primary": "#067370",
	"page": "_23ccRjp2-Page-module-page"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/support/layout/Page/Page.module.scss
// module id = 758
// module chunks = 0